import { CpuChipIcon } from "@heroicons/react/24/outline";

export function TypingIndicator() {
  return (
    <div className="flex gap-3">
      <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center">
        <CpuChipIcon className="w-5 h-5 text-gray-600" />
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-xs text-gray-500">AI Assistant</span>
        <div className="bg-gray-100 rounded-lg px-3 py-2">
          <div className="flex gap-1">
            <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
            <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
            <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
          </div>
        </div>
      </div>
    </div>
  );
}